import { Grid } from '@mui/material';
import React from 'react';
import { TFunction } from 'i18next';
import { TABLE_COLUMNS_IDS } from './tableColumns';
import { IAcl } from '../../../../types/interfaces/acl';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';
import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';

export function getCellReducers(
  t: TFunction,
  classes: any,
  { canDelete, canEdit },
  onEdit: (changeRequest: IAcl) => void,
  onDelete: (changeRequest: IAcl) => void,
) {
  return [
    {
      id: TABLE_COLUMNS_IDS.ROLE,
      cellReducer: (acl: IAcl) => {
        return (
          <div className={classes.role}>
            {acl.role && t(`common.${acl.role?.name}`)}
          </div>
        );
      },
    },
    {
      id: TABLE_COLUMNS_IDS.USER,
      cellReducer: (acl: IAcl) => {
        return (
          <div className={classes.user}>
            {acl.user?.firstname} {acl.user?.firstname}
          </div>
        );
      },
    },
    {
      id: TABLE_COLUMNS_IDS.EMAIL,
      cellReducer: (acl: IAcl) => {
        return <div className={classes.userEmail}>{acl.user?.email}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.PERMISSION,
      cellReducer: (acl: IAcl) => {
        return <div className={classes.permission}>{acl.permission}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.ACCESS,
      cellReducer: (acl: IAcl) => {
        return (
          <div className={classes.access}>
            {t(`superAdminDashboard.${acl.access}`)}
          </div>
        );
      },
    },
    !canEdit && !canDelete
      ? null
      : {
          id: TABLE_COLUMNS_IDS.ACTIONS,
          cellReducer: (acl: IAcl) => {
            return (
              <div className={classes.actions}>
                <Grid
                  className={classes.tdDefault}
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  wrap="nowrap">
                  <Grid
                    container
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={1}
                    wrap="nowrap">
                    {canEdit && (
                      <EditActionButton
                        onClick={() => {
                          onEdit(acl);
                        }}></EditActionButton>
                    )}

                    {canDelete && (
                      <DeleteActionButton
                        onClick={() => {
                          onDelete(acl);
                        }}></DeleteActionButton>
                    )}
                  </Grid>
                </Grid>
              </div>
            );
          },
        },
  ].filter(Boolean);
}
